export default "__VITE_ASSET__ef92c6db__"